export default {
	skyInput: () => import('./skyInput.vue'),
	skyTextarea: () => import('./skyTextarea.vue'),
	skyRadio: () => import('./skyRadio.vue'),
	skyRadioBtn: () => import('./skyRadioBtn.vue'),
	skySelect: () => import('./skySelect.vue'),
	skySelectInput: () => import('./skySelectInput.vue'),
	skyCheckbox: () => import('./skyCheckbox.vue'),
	skyCheckboxPanel: () => import('./skyCheckboxPanel.vue'),
	skyCascaderPanel: () => import('./skyCascaderPanels.vue'),
	skyDatePicker: () => import('./skyDatePicker.vue'),
	skyDatePickerRange: () => import('./skyDatePickerRange.vue'),
	skyWeektime: () => import('./skyWeektime.vue'),
	skyTiming: () => import('./skyTiming.vue'),
	skyProKeywords: () => import('./proKeywords/proKeywords.vue'),
	skySlogan: () => import('./slogan/skySlogan.vue'),
	selectProductDetail: () => import('./selectProduct/selectProductDetail.vue'),
};
